const obscureText = (text, splitter) => {
    return text.split(splitter).map((t) => `${t.substring(0,4)}${[...t.substring(4)].map(() => "*").join('')}`).join(splitter);
}

const obscureEmail = (text, splitter = "@") => {
    const [first, last] = text.split(splitter);
    return  `${first.substring(0,4)}${[...first.substring(4), first.length-1].map(() => "*").join('')}@${last}`;
}

export {
    obscureText,
    obscureEmail
}